import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";
// import {MAIN_TXT_COLOR} from "../contants/themes"
import {
	MdHome as HomeIcon,
	MdInsertDriveFile as ContractIcon,
	MdAddCircle as PlusIcon,
	MdNotifications as NotificationIcon,
	MdAccountCircle as UserIcon

} from "react-icons/md";
import { BsFillBarChartFill as ClaimIcon } from "react-icons/bs"
const MAIN_TXT_COLOR = "var(--color-primary)"
const useStyles = makeStyles({
	active: {
		color: "var(--color-primary)",
		fontWeight: "bold"
	}
});
const contractFlow = ['contract', 'contract-detail', 'create-claim']
const Navigation = props => {
	const location = useLocation();
	const classes = useStyles();
	const history = useHistory()
	const [activeTabs, setActiveTabs] = useState(props.name ? props.name : location.pathname.split("/")[1])

	useEffect(() => {
		switch (activeTabs) {
			case '/':
			case 'home':
				history.push('/')
				break;
			case 'contract':
				history.push('/contract')
				break;
			case 'claim':
				history.push('/claim')
				break;
			case 'account':
				history.push('/account')
				break;
			default:
				break;
		}
	}, [activeTabs])

	useEffect(() => {
		setActiveTabs(location.pathname.split("/")[1])
	}, [location.pathname])

	return (
		<div className='bottom-nav'>
			<div className='bn-tab item_link'
				onClick={() => setActiveTabs('home')}
			>
				<a className={"btn btn-navLink"}>
					<div className={"nav-icon"}>
						{activeTabs === 'home' || activeTabs === '/' || !activeTabs ?
							<HomeIcon
								size='20'
								color={MAIN_TXT_COLOR}
							/> :
							<HomeIcon
								size='20'
								color={"var(--nav-txt-color)"}
							/>
						}
					</div>
					<div className={"nav-txt " + classNames({ [classes.active]: activeTabs === 'home' || activeTabs === '/' })}>Trang chủ</div>
				</a>


			</div>
			<div className='bn-tab'
				onClick={() => setActiveTabs('contract')}
			>
				<a className={"btn btn-navLink"}>
					<div className={"nav-icon"}>
						{activeTabs.includes("contract") ?
							<ContractIcon
								size='20'
								color={MAIN_TXT_COLOR}
							/> :
							<ContractIcon
								size='20'
								color={"var(--nav-txt-color)"}
							/>}
					</div>
					<div className={"nav-txt " + classNames({ [classes.active]: contractFlow.includes(activeTabs) })}>Hợp đồng</div>
				</a>

			</div>
			<div className='bn-tab'
				onClick={() => setActiveTabs('contract')}
				style={{ marginTop: "-20px" }}
			>
				<a className={"btn btn-navLink "}>
					<div className={"nav-icon"}>
						{contractFlow.includes(activeTabs) ?
							<PlusIcon
								size='40'
								color={MAIN_TXT_COLOR}
							/> :
							<PlusIcon
								size='40'
								color={"var(--nav-txt-color)"}
							/>
						}
					</div>
					<div className={"nav-txt "}>Báo bồi thường</div>
				</a>

			</div>

			<div className='bn-tab'
				onClick={() => setActiveTabs('claim')}
			>
				<a className={"btn btn-navLink"}>
					<div className={"nav-icon"}>
						{activeTabs.includes("claim") ?
							<ClaimIcon
								size='20'
								color={MAIN_TXT_COLOR}
							/> :
							<ClaimIcon
								size='20'
								color={"var(--nav-txt-color)"}
							/>
						}
					</div>
					<div className={"nav-txt " + classNames({ [classes.active]: activeTabs === 'claim' })}>Bồi Thường</div>
				</a>

			</div>
			<div className='bn-tab'
				onClick={() => setActiveTabs('account')}
			>
				<a className={"btn btn-navLink"}>
					<div className={"nav-icon"}>{activeTabs.includes("account") ?
						<UserIcon
							size='20'
							color={MAIN_TXT_COLOR}
						/> :
						<UserIcon
							size='20'
							color={"var(--nav-txt-color)"}
						/>
					}
					</div>
					<div className={"nav-txt " + classNames({ [classes.active]: activeTabs.includes("account") })}>Tài khoản</div>
				</a>

			</div>
		</div>
	)
}

export default Navigation
